import { render, staticRenderFns } from "./Sidebar-menu.vue?vue&type=template&id=363c7a86"
import script from "./Sidebar-menu.vue?vue&type=script&lang=js"
export * from "./Sidebar-menu.vue?vue&type=script&lang=js"
import style0 from "./Sidebar-menu.vue?vue&type=style&index=0&id=363c7a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports